var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#959598",
    strokeWidth: 0.8,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1a9.253 9.253 0 0 1 4.89 1.385c3.8 2.357 4.08 7.224 1.051 10.782A45.564 45.564 0 0 1 9 19a45.564 45.564 0 0 1-5.942-5.833C.031 9.61.311 4.742 4.11 2.385A9.253 9.253 0 0 1 9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.96V7.265a.791.791 0 0 0-.8-.783h-.8M7.4 11.96h3.2M9 4.526c.11 0 .2.087.2.195M8.8 4.721c0-.108.09-.195.2-.195M9 4.917c-.11 0-.2-.088-.2-.196M9.2 4.721c0 .108-.09.196-.2.196"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/more-info.36a59018.svg";
export { ForwardRef as ReactComponent };